<script lang="ts">
    import {
        InlineLoading,
        StructuredList, 
        StructuredListBody, 
        StructuredListCell, 
        StructuredListHead, 
        StructuredListRow} from "carbon-components-svelte";
    import type {Requests} from "../libreries/Requests";
    import {selectedTenant} from "../stores";
    import type { Tenant } from "../models/Tenant";
    import type { Building } from "../models/Building";
    import { onMount } from "svelte";
    import {Helpers} from "../utilities/Helpers";

    export let requests: Requests;
    let tenant: Tenant;
    let buildings: Building[] = [];
    let promise: Promise<any>;

    onMount(() => {
        selectedTenant.subscribe((value) => {
            tenant = value;
            promise = getBuildings();
        })
    })

    async function getBuildings(){
        buildings = await requests.getBuildings(tenant.id);
    }
</script>

{#await promise}
<InlineLoading />
{:then} 
{#if tenant}
    <h4 class="margin-bottom-16">
        Buildings di {tenant.name}
    </h4>
{/if}
<StructuredList>
    <StructuredListHead>
    <StructuredListRow head class="header-row">
        <StructuredListCell head>Nome</StructuredListCell>
        <StructuredListCell head>Orari di apertura</StructuredListCell>
        <StructuredListCell head>Stato</StructuredListCell>
        <StructuredListCell head>Occupazione massima</StructuredListCell>
        <StructuredListCell head>Occupazione attuale</StructuredListCell>
    </StructuredListRow>
    </StructuredListHead>
    <StructuredListBody>
        {#each buildings as building, index}
        <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
            <StructuredListCell>{building.name}</StructuredListCell>
            <StructuredListCell>
                {Helpers.formatOpeningHours(building.openHours)}
            </StructuredListCell>
            <StructuredListCell>
                {#if building.status === "Open"}
                Aperto
                {:else if building.status === "Close"}
                Chiuso
                {:else}
                -
                {/if}
            </StructuredListCell>
            <StructuredListCell>{building.maxOccupancy}</StructuredListCell>
            <StructuredListCell>{building.currentOccupancy}</StructuredListCell>
        </StructuredListRow> 
        {/each}
    </StructuredListBody>
</StructuredList>
{/await}